import React, { useState, useEffect } from "react";
import { Popup } from "@progress/kendo-react-popup";
import { Button } from "@progress/kendo-react-buttons";
import { Checkbox } from "@progress/kendo-react-inputs";
import { FaFilter } from "react-icons/fa";

export const GridColumnsFilterHeader = ({
  thProps,
  headerProps,
  onTogglePopup,
  setAnchorElement,
}) => {
  const th = thProps || headerProps;

  return (
    <th {...th} className="text-center">
      <span
        ref={setAnchorElement}
        role="button"
        tabIndex={0}
        onClick={onTogglePopup}
        onKeyDown={(e) => {
          if (e.key === "Enter") onTogglePopup();
        }}
        style={{ cursor: "pointer" }}
      >
        <Button
          className="common-btn"
          style={{
            width: "40px",
            minWidth: "35px",
            height: "40px",
          }}
        >
          <FaFilter color="white" size={16} />
        </Button>
      </span>
    </th>
  );
};

export const GridColumnsFilterPopup = ({
  anchor,
  show,
  onClose,
  columns: columnsProp,
  onColumnsChange,
}) => {
  const [columns, setColumns] = useState(columnsProp);

  useEffect(() => {
    setColumns(columnsProp);
  }, [columnsProp]);

  const visibleCount = columns.filter((c) => c.show).length;

  const applyColumnsChange = (newColumns) => {
    setColumns(newColumns);
    onColumnsChange(newColumns);
  };

  const handleToggle = (field) => {
    const target = columns.find((c) => c.field === field);
    if (!target || (target.show && visibleCount === 1)) return;

    applyColumnsChange(
      columns.map((col) =>
        col.field === field ? { ...col, show: !col.show } : col,
      ),
    );
  };

  const handleReset = () => {
    applyColumnsChange(columns.map((col) => ({ ...col, show: true })));
    onClose();
  };

  if (!anchor) return null;

  return (
    <Popup
      anchor={anchor}
      show={show}
      onClose={onClose}
      popupClass="rounded-3 p-2"
      anchorAlign={{ horizontal: "right", vertical: "bottom" }}
      popupAlign={{ horizontal: "right", vertical: "top" }}
    >
      <div className="d-flex align-items-start flex-column p-2 mx-2">
        <div className="mt-2 fs-sm">
          Set Filters
        </div>
        <hr className="w-100 my-1" />
        {columns.map((column) => (
          <div key={column.field} className="w-100 mt-1">
            <Checkbox
              checked={column.show}
              disabled={column.show && visibleCount === 1}
              onChange={() => handleToggle(column.field)}
              label={column.title}
            />
          </div>
        ))}
        <div className="d-flex justify-content-between w-100 mt-3">
          <Button
            className="common-btn bgBtnSecondary me-2"
            onClick={handleReset}
          >
            Reset
          </Button>
          <Button className="common-btn" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Popup>
  );
};

export const mergeColumnsWithSavedSettings = (defaultColumns, savedValue) => {
  if (savedValue === undefined || savedValue === null || savedValue === "") {
    return defaultColumns;
  }
  try {
    const parsed =
      typeof savedValue === "string" ? JSON.parse(savedValue) : savedValue;
    return defaultColumns.map((col) => ({
      ...col,
      show:
        parsed[col.field] !== undefined ? Boolean(parsed[col.field]) : col.show,
    }));
  } catch {
    return defaultColumns;
  }
};

export const columnsToSettingValue = (columns) =>
  JSON.stringify(Object.fromEntries(columns.map((c) => [c.field, c.show])));
